export type Theme = {
  name: string;
  colours: Record<string, string>;
};

export const darkTheme: Theme = {
  name: 'dark',
  colours: {
    bg: '#15161B',
    blue: '#406E8E',
    accent: '#92AEC0',
    fg: '#E4EEF1',
  },
};

export const lightTheme: Theme = {
  name: 'light',
  colours: {
    bg: '#E4EEF1',
    accent: '#406E8E',
    blue: '#92AEC0',
    fg: '#15161B',
  },
};

declare module 'styled-components' {
  export interface DefaultTheme extends Theme {}
}
